<!--
  - Copyright (c) 2020. Minerva Networks.
  - All rights reserved.
  -->

<template>
  <div></div>
</template>
<script>
import { mapState } from 'vuex';
import get from 'lodash.get';
import slugify from 'slugify';

export default {
  beforeMount() {
    // eslint-disable-next-line no-debugger
    debugger;
    this.deleteCookie(`${window.TOK_NS}storageAccessData`);
    localStorage.removeItem(`${window.TOK_NS}storageAccessData`);
    this.$ls.remove('availablePlans');
    localStorage.removeItem(`${window.TOK_NS}storageHomeData`);
    const tmpHD = this.$ls.get('storageHomeData');
    get(tmpHD, 'category_videos', []).forEach((category) => {
      this.$ls.remove(`cat_${slugify(category.title)}`);
    });
    window.app.$store.state.loginInfo = false;
    window.app.$store.state.home = false;
    window.app.$store.state.me = false;
    this.$router.push('/home');
  },
  methods: {
    setCookie(name, value, days) {
      const d = new Date();
      d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
      document.cookie = `${name}=${JSON.stringify(value)};path=/;expires=${d.toGMTString()}`;
      // document.cookie = name + '=' + JSON.stringify(value) + ';path=/;expires=' + d.toGMTString();
    },
    deleteCookie(name) {
      this.setCookie(name, '', -1);
    },
  },
  computed: {
    ...mapState(['namespace', 'home']),
  },
};
</script>
